var AdEvents = /* @__PURE__ */ ((AdEvents2) => {
  AdEvents2["AdStreamLoading"] = "AD_STREAM_LOADING";
  AdEvents2["AdStreamLoaded"] = "AD_STREAM_LOADED";
  AdEvents2["AdLoading"] = "AD_LOADING";
  AdEvents2["AdLoaded"] = "AD_LOADED";
  AdEvents2["AdPlaying"] = "AD_PLAYING";
  AdEvents2["AdClicked"] = "AD_CLICKED";
  AdEvents2["AdStopping"] = "AD_STOPPING";
  AdEvents2["AdStopped"] = "AD_STOPPED";
  AdEvents2["AdContentPlay"] = "AD_CONTENT_PLAY";
  AdEvents2["AdContentPause"] = "AD_CONTENT_PAUSE";
  AdEvents2["AdSkippable"] = "AD_SKIPPABLE";
  AdEvents2["AdRequestLoaded"] = "AD_REQUEST_LOADED";
  AdEvents2["AdComplete"] = "AD_COMPLETE";
  AdEvents2["AdBreakStarted"] = "AD_BREAK_STARTED";
  AdEvents2["AdBreakEnded"] = "AD_BREAK_ENDED";
  AdEvents2["AdProgress"] = "AD_PROGRESS";
  AdEvents2["AdError"] = "AD_ERROR";
  AdEvents2["AllAdsCompleted"] = "ALL_ADS_COMPLETED";
  AdEvents2["AdCuepointsChanged"] = "AD_CUEPOINTS_CHANGED";
  return AdEvents2;
})(AdEvents || {});
var AdFormat = /* @__PURE__ */ ((AdFormat2) => {
  AdFormat2["GoogleIma"] = "VAST_4";
  AdFormat2["GoogleImaDai"] = "GOOGLE_IMA_DAI";
  AdFormat2["FreeWheel"] = "FREEWHEEL";
  AdFormat2["Generic"] = "GENERIC";
  return AdFormat2;
})(AdFormat || {});
var AdContainerType = /* @__PURE__ */ ((AdContainerType2) => {
  AdContainerType2["Parent"] = "PARENT";
  AdContainerType2["Sibling"] = "SIBLING";
  return AdContainerType2;
})(AdContainerType || {});
var AdType = /* @__PURE__ */ ((AdType2) => {
  AdType2["PreRoll"] = "pre-roll";
  AdType2["MidRoll"] = "mid-roll";
  AdType2["PostRoll"] = "post-roll";
  return AdType2;
})(AdType || {});

export { AdContainerType, AdEvents, AdFormat, AdType };
